import { Name } from './Name'
import { Footer } from './Footer'
import { form } from './formState'
import { useMemo } from 'react'
import { useOnSubmit } from '../hooks/useOnSubmit'
import { useValidateForm } from '../hooks/useValidateForm'
import { initialValues } from './formState'
import { useTheme } from '@mui/material'

export function Body() {
  const onSubmit = useOnSubmit()
  const onValidate = useValidateForm()
  const theme = useTheme()

  const config = useMemo(
    () => ({
      id: 'company-add-form',
      initialValues: initialValues,
    }),
    [initialValues],
  )

  return (
    <form.Form
      onSubmit={onSubmit}
      onValidate={onValidate}
      config={config}
      footer={<Footer />}
      sx={{ minHeight: 180 }}
      fieldsPadding={`${theme.spacing(2)} 0 ${theme.spacing(3)} 0`}
      fieldsSpacing={4}
      width={420}
      disableScroll
      stopEditingOnUnmount={false}
      requireTransaction={false}
      applyPendingFitMapOnMount={false}
    >
      <Name />
    </form.Form>
  )
}
